"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldPlaceholder = exports.FieldPlaceholderDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var cell_label_1 = require("./cell-label");
var ui_1 = require("@shapeable/ui");
var sprintf_js_1 = require("sprintf-js");
var cls = (0, utils_1.classNames)('field-placeholder');
exports.FieldPlaceholderDefaultProps = {
  fieldType: 'text'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n    display: inline-flex;\n    font-size: ", ";\n  "], ["\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n    display: inline-flex;\n    font-size: ", ";\n  "])), theme_1.theme.COLOR('highlight'), theme_1.theme.COLOR('line-subtle'), theme_1.theme.UNIT(3), theme_1.theme.FONT_SIZE(14))
});
var TypeLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    border-radius: ", " 0 0 ", ";\n    padding: ", " ", "; \n    border-right: 1px solid ", ";\n    background: ", ";\n  "], ["\n    color: ", ";\n    border-radius: ", " 0 0 ", ";\n    padding: ", " ", "; \n    border-right: 1px solid ", ";\n    background: ", ";\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3), theme_1.theme.COLOR('line-subtle'), theme_1.theme.COLOR('canvas'))
});
var FieldNameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-family: ", ";\n    padding: ", " ", "; \n    \n  "], ["\n    font-family: ", ";\n    padding: ", " ", "; \n    \n  "])), theme_1.theme.FONT('mono'), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3))
});
var TypeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", " ", "; \n    color: ", ";\n    border-right: 1px solid ", ";\n    background: ", ";\n  "], ["\n    padding: ", " ", "; \n    color: ", ";\n    border-right: 1px solid ", ";\n    background: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3), theme_1.theme.COLOR('mid'), theme_1.theme.COLOR('line-subtle'), theme_1.theme.COLOR('app-chrome'))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  TypeLabel: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), TypeLabelStyles),
  Value: styled_components_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), FieldNameStyles),
  Type: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), TypeStyles)
};
var FieldPlaceholder = function (props) {
  var className = props.className,
    children = props.children,
    entityTypeLabel = props.entityTypeLabel,
    fieldName = props.fieldName;
  var t = (0, ui_1.useLang)();
  var fieldType = (0, sprintf_js_1.sprintf)(t('%s Field'), props.fieldType);
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.TypeLabel, null, entityTypeLabel), react_1.default.createElement(My.Type, null, fieldType), react_1.default.createElement(My.Value, null, fieldName));
};
exports.FieldPlaceholder = FieldPlaceholder;
exports.FieldPlaceholder.defaultProps = exports.FieldPlaceholderDefaultProps;
exports.FieldPlaceholder.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;